// extracted by mini-css-extract-plugin
module.exports = {"container":"Tooltip_container__1p3ke","button":"Tooltip_button__qXfMf","text":"Tooltip_text__2reoF"};